module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/configuration/components/configuration-dashboard.component.scss
// module id = ./src/app/configuration/components/configuration-dashboard.component.scss
// module chunks = main